var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float"},[_c('a',{attrs:{"href":_vm.activeUrl}},[_c('img',{attrs:{"src":require("../assets/images/xiaohongbao.gif")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }